import { render } from "./ViewContactPage.vue?vue&type=template&id=349a9aea&ts=true"
import script from "./ViewContactPage.vue?vue&type=script&lang=ts"
export * from "./ViewContactPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__